import { render, staticRenderFns } from "./markTested.vue?vue&type=template&id=6029dd34&"
import script from "./markTested.vue?vue&type=script&lang=ts&"
export * from "./markTested.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports